// This function is used to set items to localStorage for the purpose of A/B testing on mobile devices
export const setParamsToLocalStorage = () => {
  const urlParams = new URLSearchParams(window.location.search)
  const localStorageKey = urlParams.get('localStorageKey')
  const localStorageValue = urlParams.get('localStorageValue')

  if (localStorageKey && localStorageValue) {
    localStorage.setItem(localStorageKey, localStorageValue)
  }
}
